import { render } from "./FileInputButton.vue?vue&type=template&id=22dfc3d3&scoped=true"
import script from "./FileInputButton.vue?vue&type=script&lang=js"
export * from "./FileInputButton.vue?vue&type=script&lang=js"

import "./FileInputButton.vue?vue&type=style&index=0&id=22dfc3d3&scoped=true&lang=scss"
import "./FileInputButton.vue?vue&type=style&index=1&id=22dfc3d3&scoped=true&lang=css"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dfc3d3"]])

export default __exports__